module.exports = __webpack_public_path__ + "img/latvia.92044057.svg";